import { useMutation, useQueryClient } from '@tanstack/react-query';
import { HTTPError } from 'ky';
import { toast } from 'sonner';

import { POSTS_PER_BOARD_LIMIT } from '@/entities/board/constant';
import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { AddPostsToBoard } from '..';

export function useAddPostsToBoard() {
  const queryClient = useQueryClient();
  const queryKeys = useQueryKeys();

  return useMutation({
    mutationFn: ({ boardId, post_ids: posts }: { boardId: string; post_ids: string[] }) =>
      AddPostsToBoard(boardId, { post_ids: posts }),
    onSuccess: (_, { boardId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.board.all() });
      queryClient.invalidateQueries({ queryKey: queryKeys.board.detail(boardId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.board.postsRoot(boardId) });
    },
    onError: (error) => {
      if (error instanceof HTTPError && error.response.status === 400) {
        toast.error(`You can save up to ${POSTS_PER_BOARD_LIMIT} posts per board.`);
      }
    },
  });
}
